import {createApp} from 'vue';
import Posts from './components/posts.vue';

export class FilterApp {
    constructor(el, url) {
        const app = createApp(Posts);
        app.mount(el);
    }
}

let container = document.getElementById('posts-container');

if (container) {
    new FilterApp('#posts-container');
}

